import {Pipe, PipeTransform} from '@angular/core';
import {NgModel} from '@angular/forms';

@Pipe({
    name: 'formFieldHasError',
    pure: false,
    standalone: true
})
export class NlrFormFieldHasErrorPipe implements PipeTransform {
    transform(formField: NgModel): boolean {
        if (!formField) {
            return false;
        }
        return formField.invalid && (formField.dirty || formField.formDirective?.submitted);
    }
}
